import React from 'react';

const SincronizedArrows = (props: Record<string, unknown>): JSX.Element => (
  <svg width="20" height="14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 4L6 0v3H0v2h6v3l6-4zm2 5V6l-6 4 6 4v-3h6V9h-6z" />
  </svg>
);

export default SincronizedArrows;
